import React from "react";
import { SharedMarketPlaceEmailTemplates } from "@app/shared";

const MarketPlaceEmailTemplateList: React.FC = () => {
  return <SharedMarketPlaceEmailTemplates />;
};

export default MarketPlaceEmailTemplateList;
